/** Explicit spent-input failures, not timeouts or unrelated wallet rejections. */
export const matchSpentWalletInput = (message: string): boolean =>
  /\bPSBT references a previous output that is already spent\b/i.test(message) ||
  /\b(?:input|outpoint|UTXO)\b[^\n]{0,180}\bis already spent\b/i.test(message);

/**
 * Liquidation price mismatch in vault stone:
 * "Liquidation price mismatch between expected {expected} and specified in the stone {specified}"
 *
 * When expected < specified, collateral would overflow the max threshold.
 */
export const matchCollateralOverflow = (message: string): boolean => {
  if (!message.includes('Vault stone validation failed') || !message.includes('Liquidation price mismatch')) {
    return false;
  }

  const match = /Liquidation price mismatch between expected (\d+) and specified in the stone (\d+)/.exec(message);

  if (!match) {
    return false;
  }

  const expected = Number(match[1]);
  const specified = Number(match[2]);

  return Number.isFinite(expected) && Number.isFinite(specified) && expected < specified;
};

/**
 * Borrow request failed because a reserved UNIT UTXO was already spent:
 * "Borrow req: ... Failed to find utxo for {txid}:{vout} input for outpoint {txid}:{vout}"
 */
export const matchUnitReserveOutdated = (message: string): boolean => {
  return message.includes('Borrow req') && message.includes('Failed to find utxo for') && message.includes('input for outpoint');
};
